__turbopack_context__.v({
  "answer": "index-module-scss-module__A52-kW__answer",
  "controlInput": "index-module-scss-module__A52-kW__controlInput",
  "faqItem": "index-module-scss-module__A52-kW__faqItem",
  "question": "index-module-scss-module__A52-kW__question",
});
